import { globalVariables } from "helper/globalVariables";
import { useEffect, useRef, useState, useMemo } from "react";
import { TableWithPagination } from "shared/Components/tableWithPagination";
import { globalClasses } from "helper/globalClasses";
import { Button } from "shared/Components/button";
import { EmailWhite } from "helper/icons";
import { TrailDrawListMobileTable } from "./components/TrailDrawListMobileTable";
import { SearchDropdown } from "shared/Components/searchDropdown";
import { client } from "helper/apolloConfig";
import {
  cancelRandomDrawMutation,
  generateEntriesEmailNotificationMutation,
  getAllTrialCalendarForTrailDrawQuery,
  getRandomDogsTrialByTrialCalendarQuery,
  getRemainingTrialForDrawQuery,
  patchNewEntriesToSelectedDrawMutation,
  removeSelectedDraw,
} from "redux/features/hostSlice/trialDrawSlice/trialDrawGql";
import { downloadRandomDogsTrialByTrialCalendar } from "redux/features/reports/reportsGql";
import { useLazyQuery } from "@apollo/client";
import { SkipModal } from "container/OnBoarding/RegisterDog/Components/SkipModal";
import { handleDownload } from "helper/utils";
import { PopUpMessages } from "shared/Components/popUpMessages";
import MultiSelectDropdown from "shared/Components/multiselectDropdown";
import { ActionButton } from "shared/Components/actionButton/ActionButton";
import {
  DownloadAwaitedTrialForDraw,
  DownloadScoreRoom,
  DownloadEntriesForDraw,
  DownloadStickers
} from "./trialDraw.helper";
import PageInfo from "shared/Components/pageInfo";
import { cross } from "helper/images";
import { AddEntriesModal } from "./components/AddEntriesModal";
import { WaitlistDropdown } from "./components/WaitlistDropdown";

export const TrialDraw = () => {
  const { tableDataCls, tableDataSmallCls } = globalClasses;
  const [drawEntry, setDrawEntry] = useState("");
  const [selectedDrawEntry, setSelectedDrawEntry] = useState(null);
  const [drawEntryDropdownData, setDrawEntryDropdownData] = useState([]);
  const [chooseEntriesDropdownData, setChooseEntriesDropdownData] = useState(
    []
  );
  const [notified , setNotified] = useState(false);
  const [page, setPage] = useState(1);
  const [downloadUrl, setDownloadUrl] = useState("");
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [emailLoader, setEmailLoader] = useState(false);
  const [loader, setLoader] = useState(false);
  const [selectedTrialDogs, setSelectedTrialDogs] = useState([]);
  const [resultDataResponse, setResultDataResponse] = useState();
  const [apiData, setApiData] = useState({
    title: "",
    desc: "",
    type: "pending",
  });
  const modalRef = useRef();
  const removeDrawRef = useRef();
  const popUpModalRef = useRef();
  const addEntriesModalRef = useRef();
  const [getData, { loading, error, data, refetch }] = useLazyQuery(
    getRandomDogsTrialByTrialCalendarQuery,
    { fetchPolicy: "network-only" }
  );
  
  const [totalEntries, setTotalEntries] = useState({});

  const [manualEntriesData, setManualEntriesData] = useState([]);

  const [hiddenWaitlistDogs, setHiddenWaitlistDogs] = useState([]);

  const fetchTrialEntries = async (id) => {
    // Don't fetch if id is not available
    if (!id) return;

    try {
      const result = await client.query({
        query: downloadRandomDogsTrialByTrialCalendar,
        variables: {
          trialCalendarId: +id,
        },
        fetchPolicy: "no-cache",
      });
      setTotalEntries(result?.data?.downloadRandomDogsTrialByTrialCalendar || []);
    } catch (error) {
      console.error("Error fetching trial entries:", error);
      setTotalEntries({});
    }
  };

  let resultData = data?.getRandomDogsTrialByTrialCalendar;

  const refreshAllData = async () => {
    await Promise.all([
      refetch(),
      fetchTrialEntries(selectedDrawEntry?.trialId),
      getDogEntries(),
    ]);
  };

  useEffect(() => {
      fetchTrialEntries(selectedDrawEntry?.trialId);
  }, [manualEntriesData, selectedDrawEntry?.trialId, selectedTrialDogs]);

  const [showDrawnEntries, setShowDrawnEntries] = useState(false);

  const [trialDrawId, setTrialDrawId] = useState(null);

 console.log("resultData",resultData);

  const headData = [
    "#",
    globalVariables.element,
    globalVariables.handler,
    globalVariables.dog,
    globalVariables.dogBreed,
    globalVariables.division,
    ...(showDrawnEntries ? [globalVariables.remove] : []),
  ];

  const handlePaginationData = (pages = 1, isPaginated = false) => {
    setPage(pages);
    getData({
      variables: {
        pageNumber: pages,
        pageSize: 1000,
        trialCalendarId: parseInt(selectedDrawEntry?.trialId),
        isPaginated: isPaginated,
      },
    });
  };

  useEffect(() => {
    getDrawEntries();
  }, [drawEntry]);

  useEffect(() => {
    setDownloadUrl(resultData?.downloadUrl);
    setResultDataResponse(resultData);
    if (resultData && page === 1) {
      getDogEntries();
    }
  }, [resultData]);

  useEffect(() => {
    const getData = () => {
      if (selectedDrawEntry?.trialId) {
        handlePaginationData();
      }
    };

    getData();
  }, [selectedDrawEntry, selectedDrawEntry?.trialId]);

  // Automatically show drawn entries when a trial with already-run draw is selected
  useEffect(() => {
    if (resultDataResponse?.drawnTrial?.length > 0 && resultDataResponse?.message) {
      setShowDrawnEntries(true);
    } else {
      setShowDrawnEntries(false);
    }
  }, [resultDataResponse]);

  useEffect(() => {
    getPatchDogEntries(page);
  }, [selectedTrialDogs]);

  const getPatchDogEntries = (pageNumber) => {
    if (selectedTrialDogs?.length) {
      setPage(pageNumber);
      getPatchEntries(pageNumber);
    } else if (selectedDrawEntry?.trialId) {
      handlePaginationData(pageNumber, true);
    }
  };

  const getPatchEntries = async (pageNumber) => {
    setLoader(true);
    try {
      const result = await client.mutate({
        mutation: patchNewEntriesToSelectedDrawMutation,
        variables: {
          pageNumber: pageNumber,
          pageSize: 10,
          trialDogs: selectedTrialDogs?.map((id) => ({
            id: parseInt(id, 10),
            addData: true
          })),
        },
      });

      setLoader(false);
      const res = result?.data?.patchNewEntriesToSelectedDraw;
      if (res?.data) {
        setDownloadUrl(res?.downloadUrl);
        setResultDataResponse(res);
        setShowDrawnEntries(false);
        // Clear the selection
        setSelectedTrialDogs([]);
        // Refresh all data atomically
        await refreshAllData();
      }
    } catch (err) {
      setLoader(false);
      console.error("Error adding dog to draw:", err);
    }
  };

  const getDogEntries = async () => {
    try {
      const result = await client.query({
        query: getRemainingTrialForDrawQuery,
        variables: {
          trialCalendarId: parseInt(selectedDrawEntry?.trialId),
        },
        fetchPolicy: 'no-cache', // Force fresh data from server
      });

      let data = result?.data?.getRemainingTrialForDraw;
      if (data) {
        setChooseEntriesDropdownData(data);
      }
    } catch (err) {}
  };

  const removeSelectedDrawHandler = async () => {
    try {
      const result = await client.mutate({
        mutation: removeSelectedDraw,
        variables: {
          trialCalendarId: parseInt(selectedDrawEntry?.trialId, 10),
          trialDrawnId: parseInt(trialDrawId, 10),
        },
      });
      let data = result?.data?.removeSelectedDraw;
      setManualEntriesData(prev => prev.filter(entry => entry.id !== trialDrawId));
      if (data) {
        await refreshAllData();
        popUpModalRef.current.openModal();
        setApiData({
          ...apiData,
          title: "Success",
          desc: 'The entry has been successfully removed.',
          type: "success",
        });
      }
    } catch (err) {
      popUpModalRef.current.openModal();
      setApiData({
        ...apiData,
        title: "Error",
        desc: "Something went wrong",
        type: "pending",
      });
    }
  };

  const sendEmail = async () => {
    setEmailLoader(true);
    try {
      const result = await client.mutate({
        mutation: generateEntriesEmailNotificationMutation,
        variables: {
          trialCalendarId: parseInt(selectedDrawEntry?.trialId),
        },
      });

      const data = result?.data?.generateEntriesEmailNotification;
      if (data) {
        setEmailLoader(false);
        popUpModalRef.current.openModal();
        setApiData({
          title: globalVariables.emailSent,
          desc: globalVariables.membersNotifiedAboutSelection,
          type: "success",
        });
      }
    } catch (err) {
      popUpModalRef.current.openModal();
      setApiData({
        ...apiData,
        title: globalVariables.error,
        desc: 'Email Notification already sent',
        type: "pending",
      });
      setEmailLoader(false);
    }
  };

  const getDrawEntries = async () => {
    try {
      const result = await client.query({
        query: getAllTrialCalendarForTrailDrawQuery,
        fetchPolicy: 'no-cache',
      });

      const data = result?.data?.getAllTrialCalendarForTrailDraw;
      if (data.length >= 1) {
        setDrawEntryDropdownData(
          data?.map((e) => ({
            trialName: e.trail?.trialName,
            trialId: e?.id,
          }))
        );
      }
    } catch (err) {}
  };

  const onCancelRandomDraw = async () => {
    try {
      await client.mutate({
        mutation: cancelRandomDrawMutation,
        variables: {
          trialCalendarId: parseInt(selectedDrawEntry?.trialId, 10),
        }
      });
      // Refresh all data after canceling
      await refreshAllData();
    } catch (err) {}
  };

  const trialEntries = useMemo(() => {
    return showDrawnEntries
      ? [...manualEntriesData, ...(resultDataResponse?.drawnTrial || [])]
      : [...manualEntriesData, ...(resultDataResponse?.data || [])];
  }, [showDrawnEntries, manualEntriesData, resultDataResponse]);

  const [currentPage, setCurrentPage] = useState(1);

  const itemsPerPage = 10;

  const totalPages = useMemo(() => {
    return Math.ceil(trialEntries.length / itemsPerPage);
  }, [trialEntries.length]);

  const paginatedData = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = Math.min(startIndex + itemsPerPage, trialEntries.length);
    return trialEntries.slice(startIndex, endIndex);
  }, [trialEntries, currentPage]);
  
  const renderTableBody = () => {  
    if (!showDrawnEntries) {
      return paginatedData.map((trail, index) => (
        <tr key={trail.name}>
          <td className={`text-center ${tableDataSmallCls}`}>{index + 1}</td>
          <td className={`text-center ${tableDataSmallCls}`}>{trail.element}</td>
          <td className={`text-center ${tableDataSmallCls}`}>{trail.memberName}</td>
          <td className={`text-center ${tableDataSmallCls}`}>{trail.dog || "N/A"}</td>
          <td className={`text-center ${tableDataSmallCls}`}>{trail.breed || "N/A"}</td>
          <td className={`text-center ${tableDataSmallCls}`}>{trail.division}</td>
        </tr>
      ));
    } else {
      return paginatedData.map((trail, index) => (
        <tr key={trail.name}>
          <td className={`text-center ${tableDataSmallCls}`}>{index + 1}</td>
          <td className={`text-center ${tableDataSmallCls}`}>{trail.element}</td>
          <td className={`text-center ${tableDataSmallCls}`}>{trail.memberName}</td>
          <td className={`text-center ${tableDataSmallCls}`}>{trail.dog || "N/A"}</td>
          <td className={`text-center ${tableDataSmallCls}`}>{trail.breed || "N/A"}</td>
          <td className={`text-center ${tableDataSmallCls}`}>{trail.division}</td>
          <td className={`text-center ${tableDataSmallCls}`}>
            <img
              className="cursor-pointer m-auto"
              onClick={() => {
                setApiData({
                  ...apiData,
                  title: "",
                  desc: `Are you sure you want to remove ${trail.dog} from the draw?`,
                  type: "pending",
                });
                setTrialDrawId(trail?.id);
                removeDrawRef.current?.openModal();
              }}
              src={cross}
              height={24}
              width={24}
              alt=""
            />
          </td>
        </tr>
      ));
    }
  };
  
  const formatString = (title, search, division, memberName) => {
    // Split by comma to handle multiple searches
    const searches = search.split(',').map(s => s.trim());

    // Create initials for each search and append division
    const formattedSearches = searches.map(s => {
      const searchInitials = s.split(" ").map(word => word.charAt(0).toUpperCase()).join("");
      return `${searchInitials}-${division[0]}`;
    });

    // Format: Dog Name (Handler Name) (Entries)
    const handlerPart = memberName ? ` (${memberName})` : '';
    return `${title}${handlerPart} (${formattedSearches.join(', ')})`;
  }

  const handleAddFromWaitlist = async (dog) => {
    if (dog && dog.id) {
      // Add to hidden list to filter it out from the dropdown
      setHiddenWaitlistDogs(prev => [...prev, dog.id]);
      // Trigger the add to draw
      setSelectedTrialDogs([dog.id]);
    }
  };

  const renderDropdown = () => {
    // Filter out hidden dogs from the waitlist
    const filteredWaitlist = chooseEntriesDropdownData?.filter(
      (e) => !hiddenWaitlistDogs.includes(e.id)
    ) || [];

    const waitlistOptions = filteredWaitlist.map((e) => ({
      id: e.id,
      displayText: formatString(e?.dog, e.elements, e.division, e.memberName),
      data: e,
    }));

    // If no waitlist dogs, show disabled dropdown with message
    if (waitlistOptions.length === 0) {
      return (
        <WaitlistDropdown
          dropdownOptions={[]}
          placeholder="No dogs on waitlist - all dogs have been drawn"
          width="w-[320px]"
          onAddDog={handleAddFromWaitlist}
          disabled={true}
          loading={false}
        />
      );
    }

    return (
      <WaitlistDropdown
        dropdownOptions={waitlistOptions}
        placeholder={globalVariables.addFromWaitlist}
        width="w-[320px]"
        onAddDog={handleAddFromWaitlist}
        disabled={false}
        loading={loading || loader}
      />
    );
  };

  const onSelectFromDownload = async (option) => {
    switch (option) {
      case globalVariables.entries: {
        setDownloadLoader(true);
        window.open(totalEntries?.downloadUrl, "_blank");
        setDownloadLoader(false);
        return data;
      }
      case globalVariables.waitList: {
        setDownloadLoader(true);
        const data = await DownloadAwaitedTrialForDraw(
          selectedDrawEntry?.trialId
        );
        setDownloadLoader(false);
        return data;
      }
      case globalVariables.scoreCatalog: {
        setDownloadLoader(true);
        const data = await DownloadScoreRoom(selectedDrawEntry?.trialId);
        setDownloadLoader(false);
        // return data;
      }
      case globalVariables.stickers: {
        setDownloadLoader(true);
        const data = await DownloadStickers(selectedDrawEntry?.trialId);
        setDownloadLoader(false);
        return data;
      }
      default: {
      }
    }
  };

  return (
    <div className="App rounded-md min-h-screen lg:ml-[17rem] sm:pt-8 bg-white lg:p-10">
      <PageInfo
        onClick={() => {
          setSelectedDrawEntry(null);
          setDrawEntry('');
        }
        }
        title={globalVariables.trailDraw}
      >
      {totalEntries?.totalDraw  && !!selectedDrawEntry && (
        <p className="text-lg  text-gray-900 font-medium">
          Total Draw: <span className="font-bold">{totalEntries?.totalDraw}</span>
        </p>
      )}
      </PageInfo> 
      <div className=" flex items-stretch md:items-end flex-wrap justify-between gap-4 flex-col md:flex-row my-5">
        <SearchDropdown
          showCancel={false}
          label={globalVariables.TrailDrawSearchLabel}
          placeholder={globalVariables.TrailDrawSearchPlaceHolder}
          isShowClearButton={true}
          dropdownOptions={drawEntryDropdownData?.map((e) => e.trialName) ?? []}
          isFaded={true}
          width={"w-full md:w-[21rem] lg:w-80"}
          onChangeSearchText={(text) => {
            setDrawEntry(text);
          }}
          onSelectOption={(value, index) => {
            setSelectedDrawEntry(drawEntryDropdownData[index]);
            setDrawEntry(value);
          }}
          onClickClearButton={() => {
            if (selectedDrawEntry) {
              modalRef.current?.openModal();
            }
          }}
          defaultValue={drawEntry}
        />
        {!!selectedDrawEntry && (
          <div className="flex flex-col md:flex-row   gap-4   justify-end">
            <Button
              onClick={() => addEntriesModalRef.current?.openModal()}
              label={globalVariables.addAdditionalEntries}
              width={24}
              prefix={false}
            />
            <ActionButton
              actionButtonOptions={[
                globalVariables.entries,
                globalVariables.waitList,
                globalVariables.scoreCatalog,
                globalVariables.stickers,
              ]}
              label={globalVariables.download}
              width={"w-[150px]"}
              onClickOption={(option) => {
                onSelectFromDownload(option);
              }}
              loading={downloadLoader}
            />
            {/* <Button
              prefix={false}
              width={"w-full md:w-44 lg:w-[220px]"}
              label={globalVariables.downloadEntires}
              icon={DownloadWhiteAlt}
              disabled={downloadLoader}
              onClick={async () => {
                setDownloadLoader(true);
                await handleDownload(downloadUrl);
                setDownloadLoader(false);
              }}
            /> */}
            {/* {notified && ( */}
              <Button
                prefix={false}
                width={"w-full md:w-44 lg:w-[220px]"}
                label={globalVariables.notifyViaEmail}
                icon={EmailWhite}
                onClick={sendEmail}
                disabled={emailLoader}
              />
            {/* )} */}
          </div>
        )}
      </div>
      {!!selectedDrawEntry && (
        <div className="mt-4">
          <div className="flex flex-col flex-1 bg-white rounded-lg md:hidden">
            <div className="pl-4 flex flex-col gap-2 my-4">
              <span className="text-xl font-bold">
                {globalVariables.acceptedEntries}
              </span>
              
              {chooseEntriesDropdownData?.length > 0 ? renderDropdown() : null}
            </div>
            <TrailDrawListMobileTable
              trailDraws={resultDataResponse?.data ?? []}
              currentPage={page}
              totalPage={resultDataResponse?.totalPages}
              loading={loading || loader}
              error={error}
              handlePageChange={(page) => getPatchDogEntries(page)}
            />
          </div>

          {!showDrawnEntries && resultDataResponse?.drawnTrial?.length > 0 && resultDataResponse?.message ? (
            <div className="flex flex-col gap-10 h-[60vh] justify-center items-center border rounded-md shadow-100">
              <div className="mt-[10%] font-semibold text-xl text-gray-900">
                You have already drawn entries for this trial. Please check the already drawn data.
              </div>
              <Button
                prefix={false}
                width={"w-full md:w-44 lg:w-[220px]"}
                label={globalVariables.viewDrawEntries}
                onClick={() => setShowDrawnEntries(true)}
              />
            </div>
          ) : (
            <TableWithPagination
              headerComponent={
                <div className="mt-2">
                  {renderDropdown()}
                </div>
              }
              headData={headData}
              tableBody={renderTableBody()}
              tableHeight={"md:h-[calc(100vh-10rem)] lg:h-[70vh]"}
              title={globalVariables.acceptedEntries}
              totalPage={totalPages}
              handlePageChange={(page) => setCurrentPage(page)}
              loading={loading || loader}
              current={currentPage}
              persistPagination={true}
              error={error}
            />
          )}
        </div>
      )}
      <AddEntriesModal 
        modalRef={addEntriesModalRef}
        trialId={selectedDrawEntry?.trialId}
        setManualEntriesData={setManualEntriesData}
      />
      <SkipModal
        ModalHeader={globalVariables.areYouSureCancelDraw}
        ref={modalRef}
        ModalContent=""
        onSkip={() => {
          onCancelRandomDraw();
          setDrawEntry("");
          setShowDrawnEntries(false);
          setResultDataResponse(null);
          setManualEntriesData([]);
          setChooseEntriesDropdownData([]);
          setSelectedDrawEntry(null);
        }}
      />
      <SkipModal
        ModalHeader=""
        ModalContent={apiData.desc}
        ref={removeDrawRef}
        onSkip={() => {
          removeSelectedDrawHandler();
        }}
      />
      <PopUpMessages
        title={apiData.title}
        desc={apiData.desc}
        type={apiData.type}
        ref={popUpModalRef}
      />
    </div>
  );
};
